import crud from './helpers/crud';

const getTaskRoutingRules = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TASK_ROUTING_RULES',
      fail: 'FAILED_GET_TASK_ROUTING_RULES',
      end: 'FINISH_GET_TASK_ROUTING_RULES',
    },
    method: 'GET',
    url: '/api/v1/task_routing_rules',
  })
);

const createTaskRoutingRule = (ruleObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_TASK_ROUTING_RULE',
      fail: 'FAILED_CREATE_TASK_ROUTING_RULE',
      end: 'FINISH_CREATE_TASK_ROUTING_RULE',
    },
    method: 'POST',
    data: { task_routing_rule: ruleObject },
    url: '/api/v1/task_routing_rules',
  })
);

const updateTaskRoutingRule = (id, ruleObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_TASK_ROUTING_RULE',
      fail: 'FAILED_UPDATE_TASK_ROUTING_RULE',
      end: 'FINISH_UPDATE_TASK_ROUTING_RULE',
    },
    method: 'PUT',
    url: `/api/v1/task_routing_rules/${id}`,
    data: { task_routing_rule: ruleObject },
  })
);

const deleteTaskRoutingRule = (id) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_TASK_ROUTING_RULE',
      fail: 'FAILED_DELETE_TASK_ROUTING_RULE',
      end: 'FINISH_DELETE_TASK_ROUTING_RULE',
    },
    method: 'DELETE',
    url: `/api/v1/task_routing_rules/${id}`,
  })
);

const reorderTaskRoutingRules = (ruleIds) => (
  crud({
    dispatch: {
      begin: 'BEGIN_REORDER_TASK_ROUTING_RULES',
      fail: 'FAILED_REORDER_TASK_ROUTING_RULES',
      end: 'FINISH_REORDER_TASK_ROUTING_RULES',
    },
    method: 'POST',
    url: '/api/v1/task_routing_rules/reorder',
    data: { rule_ids: ruleIds },
  })
);

const getAllTaskTemplates = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_ROUTING_RULE_TEMPLATES',
      fail: 'FAILED_GET_ROUTING_RULE_TEMPLATES',
      end: 'FINISH_GET_ROUTING_RULE_TEMPLATES',
    },
    method: 'GET',
    url: '/api/v1/ema_task_templates?no_pagination=true',
  })
);

const getAllLabelsForRoutingRules = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_ROUTING_RULE_LABELS',
      fail: 'FAILED_GET_ROUTING_RULE_LABELS',
      end: 'FINISH_GET_ROUTING_RULE_LABELS',
    },
    method: 'GET',
    url: '/api/v1/labels?no_pagination=true',
  })
);

export {
  getTaskRoutingRules,
  createTaskRoutingRule,
  updateTaskRoutingRule,
  deleteTaskRoutingRule,
  reorderTaskRoutingRules,
  getAllTaskTemplates,
  getAllLabelsForRoutingRules,
};
